import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedList, FormattedMessage } from 'react-intl';

import Global from '../../../../../store/global-selectors';
import { BillingPlanPropType } from '../../../../../prop-types/billing-plan';
import { NZ_AU_BILLING_PLAN_IDS } from '../../../../../enums/billing-plan-ids';
import { EU_UK_PLAN_PROFILE_CODES } from '../../../../../enums/plan-profiles';
import { STARTUP_PLAN_CODE } from '../../../../../constants/plan-codes';

import { messages } from './messages';

export const SupportValue = ({ plan }) => {
  const subscriptionData = useSelector(Global.selectSellerSubscriptionData);
  const { planProfileCode = '' } = subscriptionData ?? {};
  if (EU_UK_PLAN_PROFILE_CODES.includes(planProfileCode)) {
    return plan.hasPhoneSupport ? (
      <FormattedMessage {...messages.emailChatPhoneKbSupport} />
    ) : (
      <FormattedMessage {...messages.emailChatKbSupport} />
    );
  }
  if (NZ_AU_BILLING_PLAN_IDS.some((id) => id === parseInt(plan.billingPlanId, 10))) {
    return plan.code.includes(STARTUP_PLAN_CODE) ? (
      <FormattedMessage {...messages.emailChatKbSupport} />
    ) : (
      <FormattedMessage {...messages.emailChatPhoneKbSupport} />
    );
  }
  const supportOptions = [];
  if (plan.hasPhoneSupport) {
    supportOptions.push(<FormattedMessage key={messages.phoneSupport.id} {...messages.phoneSupport} />);
  }
  supportOptions.push(<FormattedMessage key={messages.liveChatSupport.id} {...messages.liveChatSupport} />);

  return <FormattedList type='conjunction' value={supportOptions} />;
};

SupportValue.propTypes = {
  plan: BillingPlanPropType.isRequired,
};
